import { render, staticRenderFns } from "./pdpa.vue?vue&type=template&id=cb25bf4e&"
import script from "./pdpa.vue?vue&type=script&lang=js&"
export * from "./pdpa.vue?vue&type=script&lang=js&"
import style0 from "./pdpa.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./locale/locale.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fpages%2Fhome%2Fleuco-pdpa-view%2Fpdpa%2Fpdpa.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports